/**
 * Phase 4 identity: role and user from the URL (or the last used), device id per browser profile.
 * Phase 5 replaces this with the login / QR / approval flow; everything else keeps the same shape.
 */
export type Role = 'UAV' | 'FDC' | 'OBSERVER' | 'ADMIN';

export interface Identity {
  role: Role;
  user: string;
  deviceId: string;
  bootId: string;
}

const DEFAULT_USER: Record<Role, string> = { UAV: 'kotkas1', FDC: 'tuli1', OBSERVER: 'vaatleja1', ADMIN: 'admin' };

export function resolveIdentity(search = location.search): Identity {
  const p = new URLSearchParams(search);
  const roleParam = (p.get('role') ?? localStorage.getItem('lw.role') ?? 'OBSERVER').toUpperCase();
  const role: Role = roleParam === 'UAV' || roleParam === 'FDC' || roleParam === 'ADMIN' ? roleParam : 'OBSERVER';
  const user = p.get('user') ?? localStorage.getItem(`lw.user.${role}`) ?? DEFAULT_USER[role];
  localStorage.setItem('lw.role', role);
  localStorage.setItem(`lw.user.${role}`, user);
  let deviceId = localStorage.getItem(`lw.device.${role}`);
  if (!deviceId) {
    deviceId = `d-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(`lw.device.${role}`, deviceId);
  }
  const bootId = `b-${Math.random().toString(36).slice(2, 10)}`;
  return { role, user, deviceId, bootId };
}

export function devTag(deviceId: string | null | undefined): string {
  return (deviceId ?? '????').replace(/^d-/, '').slice(0, 4);
}
